<template>
	<nav-bar :menuItems="menuItems" :portalButton="true" />
</template>
<script>
export default {
	name: "NavigationBarSustainability",
	data: () => ({
		menuItems: [
			{ title: "Dashboard", link: "/csr/dashboard" },
			{ title: "Survey", link: "/csr" },
			{ title: "ESG Score", link: "/csr/esgscore" },
			{ title: "Knowledge Page", link: "/csr/knowledgepage" }
			/* { title: "Risk Matrix", link: "/csr/riskmatrix" },
			{ title: "Knowledge Page", link: "/csr/knowledgepage" }, */
		],
		sidebar: false
	})
}
</script>
